<template>
  <div>
    <div class="sub-menu">
      <router-link v-for="(m, mind) in menu"
                   :to="{ name: m.to }"
                   :key="`settings-link-${mind}`">
        {{ $t(m.title) }}
      </router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>

import { mapActions, mapState } from "vuex"

export default {
  name: "AccountingMonthGeneral",
  head() {
    return {
      title: this.$t('accounting'),
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      month: state => state.accounting.accountingmonth,
      counter: state => state.datatable.dataTableCounter
    }),
    monthId() {
      return this.$route.params.id
    },
    idFound() {
      return !isNaN(this.monthId)
    },
    menu() {
      if(!this.idFound) return []
      return [
        { to: 'AccountingMonthSummary', title: 'month' },
        { to: 'AccountingMonthSalaries', title: 'salaries' },
        { to: 'AccountingMonthMaterials', title: 'materials' },
        { to: 'AccountingMonthOtherIncome', title: 'other_income' },
        { to: 'AccountingMonthOtherExpense', title: 'other_expense' },
        { to: 'AccountingMonthOtherIncomeCategory', title: 'categories' },
        { to: 'AccountingMonths', title: 'totals' },
      ]
    }
  },
  methods: {
    ...mapActions(['getAccountingMonth']),
    loadMonth(monthId = null) {
      this.getAccountingMonth(monthId || this.$route.params.id).then(val => {
        this.$router.replace({ params: { id: val.id } })
      })
    }
  },
  mounted() {
    this.loadMonth()
  },
  beforeUnmount() {
    this.$store.commit('setAccountingMonth', null)
  },
  watch: {
    counter() {
      this.getAccountingMonth(this.$route.params.id)
    },
    monthId(val) {
      if(val != this.month.id) {
        this.loadMonth(val)
      }
    }
  }
}
</script>
